import ReportsDialog from './ReportsDialog';

export default ReportsDialog;
export { ReportsDialog };
